<template>
  <div class="profile bg-white">
    <div class="p-4">
      <div class>
        <div class>
          <h5 class="mt-4 text-left">Profiles</h5>
          <!-- <a-tabs type="card">
                        <a-tab-pane tab="General Profile" key="1">Content of Tab Pane 1</a-tab-pane>
                        <a-tab-pane tab="Front-End Development" key="2">Content of Tab Pane 2</a-tab-pane>
                        <a-tab-pane tab="Back-End Development" key="3">Content of Tab Pane 3</a-tab-pane>
          </a-tabs>-->
          <a-tabs defaultActiveKey="1">
            <a-tab-pane key="1">
              <span slot="tab" style="font-size: 13px;">General Profile</span>
              <div class="text-left">
                <p style="font-size: 16px" v-html="talent.AboutMe"></p>
                <!-- <p
                  style="font-size: 13px;"
                >I am backend developer with more than 7 years experience on web development. My excellent knowledge includes:</p> -->
                <!-- <div
                  :key="skills"
                  v-for="skills in generalSkills"
                  class="mb-4 font-weight-bolder"
                  style="font-size: 13px;"
                >
                  <p>* {{skills.name}} {{skills.level}}</p>
                  <p>- {{skills.frameworks}}</p>
                </div> -->
              </div>
            </a-tab-pane>
            <!--  <a-tab-pane key="2" forceRender>
              <span slot="tab" style="font-size: 13px;">Front-end</span>
              <div class="text-left">
                <h5>VueJS/Jquery Developer</h5>
                <div class>
                  <p>Experienced on:</p>

                  <p
                    :key="skills"
                    v-for="skills in feExperience"
                    class="font-weight-bolder"
                  >- {{skills}}</p>
                </div>
                <div class="my-4">
                  <p>Skills:</p>
                  <span
                    :key="skills"
                    v-for="skills in feSkills"
                    class="font-weight-bolder"
                  >{{skills}},</span>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane key="3">
              <span slot="tab" style="font-size: 13px;">Back-end</span>
              <div class="text-left">
                <h5>Experienced Back-end Developer</h5>
                <div class>
                  <p>Experienced on:</p>

                  <p
                    :key="skills"
                    v-for="skills in beExperience"
                    class="font-weight-bolder"
                  >- {{skills}}</p>
                </div>
                <div class="my-4">
                  <p>Skills:</p>
                  <span
                    :key="skills"
                    v-for="skills in beSkills"
                    class="font-weight-bolder"
                  >{{skills}},</span>
                </div>
              </div>
            </a-tab-pane> -->
          </a-tabs>
          <div>
            <!-- <h6 class="text-left font-weight-bold">I am problem solving, eager to learn new things if needed, Does Something works for you? Let's get in touch.</h6> -->
          </div>
        </div>
      </div>
      <hr />
    </div>

    <div class="mt-4">
      <div class="p-4">
        <h5 style="font-size: 16px">Skills</h5>
      </div>
      <div class="p-4 border shadow-sm bg-light">
        <div class="text-left d-flex flex-wrap">
          <span
            class="bg-skills px-3 py-2 ml-3 mb-3 rounded text-size4"
            v-for="skill in skillSet"
            :key="skill"
            >{{ skill }}</span
          >
        </div>
      </div>
    </div>

    <!-- <div class="mt-4">
      <div class="p-4">
        <h5 style="font-size: 16px">Work History and Feedback</h5>
      </div>
      <div class="p-4 bg-light border shadow-sm rounded">
        <div :key="work" v-for="work in workHistory">
          <div class="row">
            <div class="col-md-9 text-left">
              <h6 class="font-weight-bolder kova-text">{{work.title}}</h6>
              <span>
                
                <span class="font-weight-light text-size4">{{work.duration}}</span>
              </span>
              <p class="text-size3">{{work.comment}}</p>
            </div>

            <div class="col-md-3 text-right float-text">
              <h6 class="font-weight-bolder kova-text">${{work.earned}}</h6>
              <h6 style="font-size: 13px">${{work.earnedPerHour}}.00 / hr</h6>
              <span>
                <img class="mr-2" src="../assets/kovatek/best.svg" alt />
                <span class="font-weight-bolder" style="font-size: 13px">9.5</span>
              </span>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </div> -->
    <view-link
      :key="viewKey"
      :link="siteLink"
      :visible="showEmbed"
      @close="
        showEmbed = false;
        viewKey++;
      "
    ></view-link>

    <div class="my-5">
      <div class="p-4">
        <h5 style="font-size: 16px">Portfolio</h5>
      </div>
      <div class="p-4 bg-light border shadow-sm">
        <div class="row px-4" v-if="projects.length">
          <div
            class="col-sm-12 col-md-5 my-3 mx-auto bg-white border add-h portfolio-link"
            :key="i"
            v-for="(link, i) in projects"
            @click="
              siteLink = link;
              showEmbed = true;
            "
          >
            <img class="favicon mt-3" :src="getFavicon(link)" />
            <h1 class="my-1">{{ formatLink(link) }}</h1>
            <p>{{ link }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ViewLink from "./ViewLink.vue";
export default {
  name: "profiles",
  components: {
    ViewLink,
  },
  props: {
    talent: { type: Object },
  },
  data() {
    return {
      siteLink: "",
      viewKey: 43,
      showEmbed: false,
      workHistory: [
        {
          title: "PHP / extJS / MVC Application Update",
          duration: " Mar 2016 - Sep 2018",
          star: 5,
          comment: "Solid experience with PHP and extJS. Good quality work.",
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48,
        },
        {
          title: "ExtJS prototype development",
          duration: "Jul 2016 - Aug 2016",
          star: 5,
          comment: "Nice job, completed on-time and high quality.",
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19,
        },
        {
          title: "PHP / extJS / MVC Application Update",
          duration: " Mar 2016 - Sep 2018",
          star: 5,
          comment: "Solid experience with PHP and extJS. Good quality work.",
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48,
        },
        {
          title: "ExtJS prototype development",
          duration: "Jul 2016 - Aug 2016",
          star: 5,
          comment: "Nice job, completed on-time and high quality.",
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19,
        },
        {
          title: "PHP / extJS / MVC Application Update",
          duration: " Mar 2016 - Sep 2018",
          star: 5,
          comment: "Solid experience with PHP and extJS. Good quality work.",
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48,
        },
        {
          title: "ExtJS prototype development",
          duration: "Jul 2016 - Aug 2016",
          star: 5,
          comment: "Nice job, completed on-time and high quality.",
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19,
        },
      ],
    };
  },
  computed: {
    skillSet() {
      const array = this.talent.CoreTechstack.split(",");
      const OtherCoreTechstacks = this.talent.OtherCoreTechstacks;
      for (let i = 0; i < OtherCoreTechstacks.length; i++) {
        array.push(OtherCoreTechstacks[i]);
      }
      return array;
    },
    projects() {
      const {
        OtherCoreTechstackProjects,
        ProjectsCompletedLinks,
        ProjectsLed,
        RemoteProjectLinks,
      } = this.talent;
      const projects = [
        ...(OtherCoreTechstackProjects || []),
        ...(ProjectsCompletedLinks || []),
        ...(ProjectsLed || []),
        ...(RemoteProjectLinks || []),
      ];
      return [...new Set(projects)];
    },
  },
  methods: {
    formatLink: (link) =>
      link
        .replace("www.", "")
        .slice(0, 2)
        .toUpperCase(),
    getFavicon(link) {
      const text = link.replace(/www./g, "");
      return `http://www.google.com/s2/favicons?domain=www.${text}`;
    },
  },
};
</script>

<style scoped>
.kova-text {
  color: #20409a;
}
.text-size1 {
  font-size: 20px;
}
.text-size2 {
  font-size: 16px;
}
.text-size3 {
  font-size: 13px;
}
.text-size4 {
  font-size: 12px;
}
.text-size5 {
  font-size: 10px;
}
.cont-progress-height {
  height: 6px;
}
.user-check-col {
  color: #41cbf6;
}
.adjust-p-size {
  font-size: 24px;
}

.text-senior {
  color: #bd6377;
}
.text-intermediate {
  color: #bdbd50;
}

.img-height {
  height: 150px;
  width: 150px;
}
.add-h {
  height: 150px;
}
.bg-skills {
  background-color: #4bb38e;
  color: #fff;
}

.portfolio-link:hover {
  background-color: #20409a !important;
  border-radius: 5px;
  cursor: pointer;
  transform: scale(1.15);
  z-index: 9;
}

.portfolio-link:hover h1,
.portfolio-link:hover p {
  color: #ffffff !important;
}

@media screen and (min-width: 992px) and (max-width: 1325px) {
  .img-height {
    height: 100px;
    width: 100px;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .img-height {
    height: 150px;
    width: 150px;
  }
}

@media screen and (max-width: 767px) {
  .img-height {
    height: 100px;
    width: 100px;
  }
  .float-text {
    display: flex;
    justify-content: space-between;
    padding-right: 50px;
  }
  .float-text h6 {
    float: left;
    /* margin-right: 40px; */
  }
}
/* 
@media screen and (max-width: 550px){
    
} */
</style>
